// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1580":"b0808091aea44cd1","3067":"ad6d939a6077ca5a","3268":"4601caaa851c573b","5570":"317cb12f816e5b16"}[chunkId] + ".js";
};